import React from 'react'

const DevloperBg =()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 587 111">
        <polygon fill="#fff" className="developers_txt" points="2,0 587.2,2.2 567.2,111.6 0,105.8 "></polygon>
        </svg>
    )
}
export default DevloperBg;